module.exports = __webpack_public_path__ + "static/media/Artboard22.e157dca5.png";